const Snackbar = ({ message, show }) => {
    return (
        <div className={`fixed bottom-40 left-1/2 transform -translate-x-1/2 mb-2 px-4 py-2 rounded shadow-lg text-white ${show ? 'bg-gray-900' : 'hidden'} transition-all opacity-30`}>
            {message}
        </div>
    );
};

export default Snackbar;
